import React from 'react';
import Slider from 'react-slick';
import './TestimonialSlider.css';
import { FaStar } from 'react-icons/fa';
import olivia from '../images/olivia.jpg'; // Replace with your actual image path
import anna from '../images/anna.jpg'; // Replace with your actual image path   
import mary from '../images/mary.jpg'; // Replace with your actual image path

const testimonials = [
  {
    name: 'Olivia Green',
    role: 'Tasker',
    message:
      'Tasker transformed our home with their exceptional service and attention to detail. Every project reflects their commitment to quality and customer satisfaction.',
    image: olivia,
  },
  {
    name: 'James Carter',
    role: 'Homeowner',
    message:
      'I couldn’t be happier with the professionalism and work quality. Definitely recommending Tasker to others.',
    image: anna,
  },
  {
    name: 'Samantha Lee',
    role: 'Interior Designer',
    message:
      'The team went above and beyond. Very responsive and the craftsmanship was top-tier!',
    image: mary,
  },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="testimonial-section">
      <Slider {...settings}>
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className="star" />
              ))}
            </div>
            <p className="testimonial-text">{item.message}</p>
            <div className="testimonial-author">
              <img src={item.image} alt={item.name} />
              <h4>{item.name}</h4>
              <span>{item.role}</span>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default TestimonialSlider;
